import React from "react";

import { ReactComponent as DownloadContentIcon } from "src/images/ws-download-proposal-image.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, { OutsideClickModes } from "../../components/Modal/Modal";

import "./ContentDownloadModal.scss";

interface Props {
  onClose: () => void;
}

export default function ContentDownloadModal({ onClose }: Props) {
  return (
    <Modal
      onClose={onClose}
      displayCancelButton
      onCancelClick={onClose}
      className="content-download-modal"
      outsideClick={OutsideClickModes.Allow}
    >
      <div className="content-download-modal__row">
        <div className="content-download-modal__content">
          <div className="content-download-modal__title">
            <IDHFormattedMessage
              id="ws_download_content_modal_title"
              defaultMessage="Check your inbox for the content package"
            />
          </div>
          <div className="content-download-modal__description">
            <IDHFormattedMessage
              id="ws_download_content_modal_description"
              defaultMessage="We've sent the content package to your email. Go to your inbox to download the files."
            />
          </div>
        </div>
        <div className="content-download-modal__image">
          <DownloadContentIcon />
        </div>
      </div>
    </Modal>
  );
}
